/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, Input } from '@angular/core';
import { ContainerModel } from '@typescript-kit/view';

@Component({
  selector: 'app-accounting-shell-menu',
  templateUrl: './accounting-shell-menu.component.html',
  styleUrls: ['./accounting-shell-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountingShellMenuComponent {

  @Input()
  public model: ContainerModel;

}
